import _ from 'lodash';
import { connect } from 'react-redux';

import { SHINGLES_ADD_RECENTLY_VIEWED } from '../../../Actions';

const maxRecentlyViewed = 6;
const recentlyViewedDefault = [];
export const shinglesRecentlyViewedReducer = (state, action) => {
  let newState = _.cloneDeep(state || recentlyViewedDefault);

  switch (action.type) {
    case SHINGLES_ADD_RECENTLY_VIEWED:
      // Remove item if it's already on the list
      newState = newState.filter(fav => fav !== action.color);
      // Add item to the from of the list
      newState.unshift(action.color);
      // Limit recent views to 6 items
      newState = newState.slice(0, maxRecentlyViewed);
      return newState;
    default:
      return newState;
  }
};

export const addToRecentlyViewed = color => ({ type: SHINGLES_ADD_RECENTLY_VIEWED, color });

export const connectRecentlyViewed = connect(state => ({ recentlyViewed: state.shinglesRecentlyViewed }), {
  addToRecentlyViewed,
});
